export default "__VITE_ASSET__4$A22eqt__";